(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-hide-addtocart"]) return;
  try {
    
        $('select').change(function() {

        //選択したvalue値を変数に格納
        var val = $('option:selected').attr('data-price');

        //選択したvalue値をp要素に出力
        $('#display-price').text(val);
        });
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-test"]) return;
  try {
    
        $('select').change(function() {

        //選択したvalue値を変数に格納
        var val = $('option:selected').attr('data-price');

        //選択したvalue値をp要素に出力
        $('#display-price').text(val);
        });
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
          $('select').change(function () {
            var val = $('option:selected').attr('data-price');

            $('#display-price').text(val);
          });

          $('input[name="radioAlphabet"]').on('change', (e) => {
            $('#order').val(e.target.value);

            document
              .querySelector('#order')
              .dispatchEvent(
                new CustomEvent('change', {
                  bubbles: true
                })
              );
          });
        
  } catch(e) { console.error(e); }
})();
})();
